<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col>
          <router-link class="btn" :to="{name: 'EXCMSlaUpdate', params: { id: item['@id'] }}">{{ $t('buttons.edit') }}</router-link>
          <button class="btn btn-warning" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
          <!--<button class="btn btn-danger" @click="deleteItem(item)">{{ $t('buttons.delete') }}</button>-->
          <router-link :to="{ name: 'EXCMSlaList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-header">
              <h4 class="card-title">{{$t('views.excmsla.show.title')}}</h4>
            </div>
            <div class="card-body">
              <b-row v-if="item">
                <b-col>
                  <p><b>{{$t('views.excmsla.show.name')}}:</b> {{ item.title }}</p>
                  <p><b>{{$t('views.excmsla.show.symbol')}}:</b> {{ item.symbol }}</p>
                  <p><b>{{$t('views.excmsla.show.description')}}:</b> {{ item.description }}</p>
                  <p><b>{{$t('views.excmsla.show.reactionTime')}}:</b> {{ item.reactionTime }} {{ reactionTimeUnit }}</p>
                  <p><b>{{$t('views.excmsla.show.bypassTime')}}:</b> {{ item.bypassTime }} {{ bypassTimeUnit }}</p>
                  <p><b>{{$t('views.excmsla.show.repairTime')}}:</b> {{ item.repairTime }} {{ repairTimeUnit }}</p>
                </b-col>
              </b-row>
              <!--<b-row>-->
                <!--<b-col>-->
                  <!--<router-link-->
                          <!--v-if="item"-->
                          <!--:to="{ name: 'EXCMSlaList' }"-->
                          <!--class="btn btn-default">{{ $t('buttons.backToList') }}</router-link>-->
                  <!--<button-->
                          <!--class="btn btn-danger"-->
                          <!--@click="deleteItem(item)">{{ $t('buttons.delete') }}</button>-->
                <!--</b-col>-->
              <!--</b-row>-->
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import getId from '@/utils/getIdFromLink'

export default {
  computed: mapGetters({
    deleteError: 'excmsla/del/error',
    error: 'excmsla/show/error',
    isLoading: 'excmsla/show/isLoading',
    item: 'excmsla/show/retrieved'
  }),

  components: {
    Loader
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  data () {
    return {
      reactionTimeUnit: null,
      bypassTimeUnit: null,
      repairTimeUnit: null
    }
  },

  watch: {
    deleteError: function (val) {
      if (val !== '') {
        this.$Swal({
          title: val,
          type: 'error',
          showConfirmButton: true
        })
      }
    }
  },

  methods: {
    ...mapActions({
      del: 'excmsla/del/del',
      reset: 'excmsla/show/reset',
      retrieve: 'excmsla/show/retrieve'
    }),

    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_slas/' + this.getIdLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.$router.push({ name: 'EXCMSlaList' })
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },

    redirectAfterDelete () {
      if (this.deleteError === '') {
        this.$router.push({ name: 'EXCMSlaList' })
      } else {
        this.$store.state.excmsla.del.error = ''
      }
    },

    getIdLink (link) {
      return getId(link)
    },

    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.del(item).then(() => this.redirectAfterDelete())
          // this.del(item).then(
          //   console.log(this.error)
          //   this.redirectAfterDelete()
          // )
        }
      })
    }
  }
}
</script>
